class Header {
	constructor(config) {
		this.config = Object.assign({
			scope: 'header',
			openSearchButton: '[data-header="search"]',
			searchInputWrapper: '[data-header="searchBox"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		this.$scope.on('click', this.config.openSearchButton, this.toggleSearch.bind(this));
	}

	toggleSearch(event) {
		event.preventDefault();
		this.$scope.find(this.config.searchInputWrapper).toggleClass('open');
		$('#search-form input[type="search"]').focus();
	}
}

export default new Header;